import UserRole from '@careerstart/wae-common/src/main/constants/user-role';

export const OTHER_AGENCY_CANDIDATE_NAME = 'Other Agency Candidate';

const sameId = (left, right) => left != null && right != null && String(left) === String(right);

/**
 * Admins can open any user. Recruiters can open a worker only when that worker
 * belongs to the recruiter's agency. Employers have no user-details access.
 */
const canLinkWorkerToUserDetails = ({
  role,
  userId,
  workerAgencyId,
  recruiterAgencyId,
  workerName,
}) => {
  if (!userId) return false;
  if (role === UserRole.ADMIN) return true;
  if (role !== UserRole.RECRUITER) return false;
  if (workerName === OTHER_AGENCY_CANDIDATE_NAME) return false;
  if (!workerAgencyId || !recruiterAgencyId) return false;
  return sameId(workerAgencyId, recruiterAgencyId);
};

export default canLinkWorkerToUserDetails;
